import React from "react";
import { useTranslation } from "react-i18next";
import { ArrowLeft, ArrowRight } from "./ProjectIcons";

interface Props {
  onClick: () => void;
  isExpanded: boolean;
}

/**
 * Icon-only chevron that collapses or expands the side menu. The glyph carries no text,
 * so the accessible name comes from `aria-label`, which names the action the click will
 * perform ("Collapse menu" while expanded, "Expand menu" while collapsed), and
 * `aria-expanded` mirrors `isExpanded` for assistive technology.
 */
const ExpandCollapseButton: React.FC<Props> = ({ onClick, isExpanded }) => {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      aria-label={isExpanded ? t("Collapse menu") : t("Expand menu")}
      aria-expanded={isExpanded}
      className={
        "absolute top-8 transform -translate-y-1/2 -right-3.5 flex items-center justify-center bg-white dark:bg-off-white-dark rounded-full p-0 cursor-pointer z-10 focus:outline-none focus-visible:ring-2 focus-visible:ring-storm-blue dark:focus-visible:ring-sky-blue"
      }
      onClick={onClick}
    >
      <span className="text-xs flex items-center">
        {isExpanded ? <ArrowLeft /> : <ArrowRight />}
      </span>
    </button>
  );
};

export default ExpandCollapseButton;
